<script setup>
const props = defineProps({
    title: {
        type: String,
    },
    subtitle: {
        type: String
    },
    divider: {
        type: Boolean,
        default: true
    }
})
</script>

<style>

</style>

<template>
    <div>
        <div class="flex items-center justify-between pb-5 gap-4">
            <div>
                <div class="text-[#101828] text-3xl font-semibold pb-1 capitalize">{{ props.title }}</div>
                <div class="text-[#475467] text-base font-normal leading-[22px]">{{ props.subtitle }}</div>
            </div>
            <slot name="rightSide"></slot>
        </div>
        <div class="bg-[#EAECF0] h-[1px] w-full mb-7" v-if="props.divider"></div>
    </div>
</template>
